import { css } from 'lit';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
.m-btn {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  border-radius: 200px;
}
.method-fg.delete,
.method-fg.get,
.method-fg.patch,
.method-fg.post,
.method-fg.put {
  color: var(--fg3);
}
`;
